let prevScrollpos = window.scrollY;
const subpage = document.querySelector('.site-subpage');

if (!subpage) {
    document.querySelector('.header').classList.add('header--hidden');
   
    window.onscroll = function () {
        let currentScrollPos = window.scrollY;
        const headerImage = document.querySelector('.header-image__wrappepr');
        const offset = headerImage.getBoundingClientRect().height;
        
        if (currentScrollPos >= offset) {
            document.querySelector('.header').classList.remove('header--hidden');
        } else {
            document.querySelector('.header').classList.add('header--hidden');
        }
        prevScrollpos = currentScrollPos;
    };
}

document.addEventListener('click', (e) => {
    const inquiryBtn = document.getElementById('header-button__inquiry');
    const contactInfo = document.querySelector('.header-overlay__inquiry-wrapper')

    if(e.target.parentElement == inquiryBtn) {
        toggleInquiryInformation();
    }

    if (!contactInfo.contains(e.target)){ 
        if(e.target.parentElement != inquiryBtn && inquiryBtn.classList.contains('--open')) {
            toggleInquiryInformation();
        }
    } 
});

function toggleInquiryInformation() {
    const mobileWidth = 768;
    let screenWidth = window.innerWidth;
    const inquiryBtn = document.getElementById('header-button__inquiry');
    const inquiryDetailsMobile = document.querySelector('.header-overlay__inquiry--mobile');
    const inquiryDetailsDesktop = document.querySelector('.header-overlay__inquiry--desktop');

    inquiryBtn.classList.toggle('--open')
    document.body.classList.toggle('no-scroll')

    if (screenWidth >= mobileWidth) {
        inquiryDetailsDesktop.classList.toggle('--open')
        inquiryBtn.classList.toggle('--hidden')
    } else {
        inquiryDetailsMobile.classList.toggle('--open')
    }
};
